import styles from "./Limit.module.css";
import { useEffect, useState } from "react";
import { LimitCurrencyConverter, LimitExtraInfo } from "../../components";
import { Button } from "../../components";
const Limit = () => {
  const [allowedButton, setAllowedButton] = useState(false);

  const LimitSellQty = document.getElementById("limit-sell-quantity")?.value;

  const LimitPriceQty = document.getElementById("limit-price-quantity")?.value;

  function handleAllowedButton() {
    setAllowedButton(false);
    if (!isNaN(LimitPriceQty) && LimitPriceQty !== 0 && LimitPriceQty > 0) {
      setAllowedButton(true);
    } else {
        setAllowedButton(false)
    }
  }
  useEffect(() => {
    handleAllowedButton();
    console.log({ LimitSellQty });
    console.log({ LimitPriceQty });
  }, [LimitSellQty, LimitPriceQty]);

  const ButtonDisplay = (
      <div className={styles.button_container}>
          {
              allowedButton ?
                  <Button title="Swap" />
                  : 
                  <Button title="Enter an amount" disabled />
                  
          }
    </div>
  );

  return (
    <div>
      <LimitCurrencyConverter handleAllowedButton={handleAllowedButton} />

      <LimitExtraInfo />
      {ButtonDisplay}
    </div>
  );
};

export default Limit;
